import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EventPreviewBigComponent } from '@modules/calendar-app/components/event-preview/event-preview-big.component';
import { EventPreviewSmallComponent } from '@modules/calendar-app/components/event-preview/event-preview-small.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { MatIconModule } from '@angular/material/icon';
import { SameDisplayDayPipe } from '@modules/form-controls/components/calendar-month-small-di/same-display-day.pipe';
import { SameDayPipe } from '@modules/utils/pipes/datetime/same-day.pipe';
import { UtilsModule } from '@modules/utils/utils.module';
import { CalendarMonthModule, CalendarWeekModule } from 'angular-calendar';
import { CalendarCellContextMenuComponent } from './components/calendar-cell-context-menu/calendar-cell-context-menu.component';
import { CalendarDayComponent } from './components/calendar-day/calendar-day.component';
import { CalendarMonthDayCellComponent } from './components/calendar-month-day-cell/calendar-month-day-cell.component';
import { CalendarMonthSmallCellComponent } from './components/calendar-month-small-cell/calendar-month-small-cell.component';
import { CalendarMonthSmallComponent } from './components/calendar-month-small/calendar-month-small.component';
import { CalendarMonthComponent } from './components/calendar-month/calendar-month.component';
import { CalendarWeekComponent } from './components/calendar-week/calendar-week.component';
import { CalendarYearDayCellComponent } from './components/calendar-year/calendar-year-day-cell.component';
import { FullCalendarYearComponent } from './components/calendar-year/calendar-year.component';
import { EventsListPopupComponent } from './components/events-list/events-list-popup.component';
import { CalendarCellContextMenuDirective } from './directives/calendar-cell-context-menu.directive';
import { ClickDirective } from '@modules/utils/directives/click/click.directive';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    ContextMenuDividerComponent, ContextMenuItemComponent, PopoverDirective,
    DragNDropModule,
    UtilsModule,
    CalendarWeekModule,
    CalendarMonthModule,
    CalendarMonthDayCellComponent,
    EventsListPopupComponent,
    CalendarMonthSmallComponent,
    CalendarMonthSmallCellComponent,
    CalendarYearDayCellComponent,
    SameDayPipe,
    SameDisplayDayPipe,
    DateFormatPipe,
    EventPreviewSmallComponent,
    EventPreviewBigComponent,
    Button2Component,
    IconComponent,
    ClickDirective,
  ],
  declarations: [
    CalendarCellContextMenuComponent,
    CalendarCellContextMenuDirective,
    CalendarDayComponent,
    CalendarMonthComponent,
    CalendarWeekComponent,
    FullCalendarYearComponent,
  ],
  exports: [CalendarDayComponent, CalendarMonthComponent, CalendarWeekComponent, FullCalendarYearComponent],
})
export class FullCalendarModule {}
